import { createAction } from 'redux-actions';
import {
  getFeatureInfoForAllGeos,
  getFeatureFlagsForAllGeos,
} from 'api/tieout-info-api';

export const featureInfoLoading = createAction('FEATURE_INFO_LOADING');
export const featureInfoError = createAction('FEATURE_INFO_ERROR');
export const featureInfoLoaded = createAction('FEATURE_INFO_LOADED');

export const featureFlagsLoading = createAction(
  'FEATURE_FLAGS_LOADING',
);
export const featureFlagsLoaded = createAction(
  'FEATURE_FLAGS_LOADED',
);
export const featureFlagsError = createAction(
  'FEATURE_FLAGS_ERROR',
);

export const fetchFeatureInfoForAllGeos = () => async (dispatch, getState) => {
  dispatch(featureInfoLoading());
  try {
    const {
      data: { currentUser },
    } = getState();
    const response = await getFeatureInfoForAllGeos(currentUser);
    const geoToFeatureFlagMap = {};
    response.forEach((buildInfoDetails) => {
      const { data: { springProfiles = '', featureConfig } = {} } =
        buildInfoDetails;
      //we are getting springProfiles value as 'geo-env' i.e 'ame-qa'.
      // I am extracting geo information to create geoToFeatureFlagMap.
      const [geoCodeValue] = springProfiles.split('-');
      const geoCodeInUpperCase = geoCodeValue.toUpperCase();
      geoToFeatureFlagMap[geoCodeInUpperCase] = featureConfig;
    });
    await dispatch(
      featureInfoLoaded({
        response: geoToFeatureFlagMap,
      }),
    );
  } catch (error) {
    dispatch(featureInfoError(error));
  }
};

// fetching application feature flags for all geos
export const fetchFeatureFlags = () => async (dispatch, getState) => {
  dispatch(featureFlagsLoading());
  try {
    const {
      data: { currentUser },
    } = getState();
    const response = await getFeatureFlagsForAllGeos(currentUser);
    await dispatch(
      featureFlagsLoaded({
        response,
      }),
    );
  } catch (error) {
    dispatch(featureFlagsError(error));
  }
};
